import React from "react";
import styles from "./StatsBar.module.css";
import { TrendingUp, Clock, Globe, Phone } from "lucide-react";

const stats = [
    {
        icon: <TrendingUp size={20} />,
        value: "99.9%",
        label: "Uptime SLA",
    },
    {
        icon: <Clock size={20} />,
        value: "< 900ms",
        label: "Response Latency",
    },
    {
        icon: <Globe size={20} />,
        value: "10+",
        label: "Languages",
    },
    {
        icon: <Phone size={20} />,
        value: "1M+",
        label: "Calls/Month",
    },
];

const StatsBar = () => {
    return (
        <section className={styles.statsSection}>
            <div className={styles.container}>
                {stats.map((item, index) => (
                    <div
                        key={index}
                        className={styles.statCard}
                        style={{ animationDelay: `${index * 0.15}s` }}
                    >
                        <div className={styles.iconBox}>{item.icon}</div>
                        <h3 className={styles.value}>{item.value}</h3>
                        <p className={styles.label}>{item.label}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default StatsBar;